module.exports = __webpack_public_path__ + "img/header-3.9b15a06.jpg";